import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Paste your landing page URL",
    description:
      "Enter your domain or target landing page. Upfixe immediately scrapes your page and generates a structured value-prop doc without manual typing.",
  },
  {
    number: "02",
    title: "Generate 5 structured ad groups in 60s",
    description:
      "Our engine pulls live Keyword Planner data, clusters keywords into 5 strategic ad groups (ROI, Volume, Features, Intent, Solutions), and auto-applies negative keyword filters.",
  },
  {
    number: "03",
    title: "Review & publish paused",
    description:
      "Inspect 15 headlines and 4 descriptions per group. Publish directly to Google Ads as paused with one click — or run the whole workflow via Claude / ChatGPT MCP.",
  },
];

const HowItWorksSection = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <Badge className="px-3 py-1 text-sm bg-primary/10 text-primary border-primary/20 mb-4">
            How It Works
          </Badge>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            From landing page URL to Google Ads in 60 seconds
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            No complex setup wizards. Paste your URL, get 5 optimized ad groups with negative filters, and push to Google Ads safely.
          </p>
        </div>

        <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-3 md:gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="relative text-center md:text-left"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.15 }}
            >
              <div className="text-6xl font-bold text-primary/10 mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {step.description}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-4 w-8 text-border">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
